const store = new Map<string, boolean>();

export const loadScript = ({ src }: { src: string }): Promise<void> => {
  if (store.get(src)) {
    return Promise.resolve();
  }

  store.set(src, true);

  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;

      script.addEventListener('load', () => resolve());

      script.addEventListener('error', () =>
        reject(new Error(`Failed to load script with src ${src}`))
      );

      document.head.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};
